import { Flex } from '@radix-ui/themes';
import React from 'react';
import Container from './components/Container';
import { fetcher } from '@/lib/utils';
import useSWR from 'swr';
import { AuctionStatistic } from './api/statistics/auction/[auctionId]/route';
import { AuctionWithRevenue } from './api/revenue/route';
import OverviewTitle from './components/overview/OverviewTitle';
import CurrentAuctionStatisticsPanel from './components/overview/CurrentAuctionStatisticsPanel';
import ViewAuctionButton from './components/overview/ViewAuctionButton';
import RecentAuctions from './components/overview/RecentAuctions';
import PreviewAuctionButton from './admin/auctions/[auctionId]/PreviewAuctionButton';
import { AuctionState } from '@prisma/client';

interface Props {
  previousAuctions: AuctionWithRevenue[];
}

const AdminHomeOverviewTab = ({ previousAuctions: auctions }: Props) => {
  const highlightedAuction = auctions?.find(a => (a.auctionState === AuctionState.AUCTION) ||
    a.auctionState === AuctionState.SOFT_CLOSING) ??
    auctions?.[0];

  const currentAuctionExists = !!highlightedAuction;

  const { data: currentAuctionStatistics, isLoading: currentAuctionStatisticsLoading } =
    useSWR<AuctionStatistic[]>(`/api/statistics/auction/${highlightedAuction?.id}`, fetcher)
  const totalRevenue: number = auctions?.reduce((acc, auction) => acc + auction.revenue, 0) || 0;

  return (
    <Container className="mt-5 mx-0 w-full min-h-96">
      <Flex className="w-full" justify="start" gap="6">
        <Flex direction="column" className="w-3/5 border rounded-xl p-6 pb-3 shadow">
          <OverviewTitle currentAuction={highlightedAuction} />
          <CurrentAuctionStatisticsPanel
            currentAuctionExists={currentAuctionExists}
            currentAuctionStatistics={currentAuctionStatistics ?? []}
            currentAuctionStatisticsLoading={currentAuctionStatisticsLoading}
          />
          <Flex justify="end" gap="2">
            <PreviewAuctionButton auctionId={highlightedAuction?.id} />
            <ViewAuctionButton currentAuction={highlightedAuction} />
          </Flex>
        </Flex>
        <RecentAuctions auctions={auctions} totalRevenue={totalRevenue} />
      </Flex>
    </Container>
  );
}

export default AdminHomeOverviewTab
